<template>
    <div class="fd-com-page">
        <MyTitle theTitle="担保申请">
            <div>(<span v-text="total"></span>)</div>
        </MyTitle>
        <div class="fd-com-search">
            <van-search
                placeholder="输入申请编号/申请人/申请法院/担保机构"
                v-model="keyWord"
                @search="onSearch">
            </van-search>
            <van-icon class="fd-com-btn-refresh" name="replay" @click="refresh"/>
        </div>
        <div class="fd-com-nodata" v-if="total === 0">
            暂无数据
        </div>
        <van-list
            class="fd-com-card-list"
            v-else
            v-model="loading"
            :finished="finished"
            :finished-text="loading ? '加载中...' : '没有更多了'"
            @load="loadData">
            <div
                class="fd-com-card"
                v-for="(item, index) of list"
                :key="index"
                @click.stop="goDetail(item)">
                <h3 class="fd-com-card-title">
                    财产保全-{{ item.cBqlb }}
                    <van-tag v-if="item.cDbztText === '待提交' || item.cDbztText === '待交费'" type="warning" :plain="false">
                        {{ item.cDbztText }}
                    </van-tag>
                    <van-tag v-else-if="item.cDbztText === '审查完成'" type="success" :plain="false">
                        {{ item.cDbztText }}
                    </van-tag>
                    <van-tag v-else-if="item.cDbztText === '审核不通过'" type="danger" :plain="false">
                        {{ item.cDbztText }}
                    </van-tag>
                    <van-tag v-else-if="item.cDbztText === '已撤销'" :plain="false">
                        {{ item.cDbztText }}
                    </van-tag>
                    <van-tag v-else type="info" :plain="false">
                        {{ item.cDbztText }}
                    </van-tag>
                </h3>
                <ul class="fd-com-card-info">
                    <li>
                        <span class="fd-com-label">申请人</span>
                        <span class="fd-com-content">{{item.cSqrxm || '--'}}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">被申请人</span>
                        <span class="fd-com-content">{{ item.cDsrxm || '--' }}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">申请法院</span>
                        <span class="fd-com-content">{{ item.cFymc || '--' }}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">申请编号</span>
                        <span class="fd-com-content">{{ item.cSqbh || '--' }}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">担保机构</span>
                        <span class="fd-com-content">{{ item.cBxgsmc || '--' }}</span>
                    </li>
                </ul>
                <div class="fd-com-count">
                    <div class="fd-item-count">
                        <p class="fd-count">{{ item.nSqbqje }}</p>
                        <p class="fd-count-text">申请担保金额(元)</p>
                    </div>
                    <div class="fd-item-count">
                        <p class="fd-count">{{ item.nDbfy }}</p>
                        <p class="fd-count-text">建议担保费(元)</p>
                    </div>
                </div>
                <cc-button-list
                    :data="item.btnDatas"
                    @click-item="eClickBtn(...arguments, item)">
                </cc-button-list>
<!--                    <div class="fd-operation-btns">-->
<!--                        <van-popover-->
<!--                            v-if="item.btnList.length>2"-->
<!--                            v-model="item.showPopover"-->
<!--                            trigger="click"-->
<!--                            :actions="item.actions"-->
<!--                            @select="(action)=>onSelect(action,item)"-->
<!--                            placement="bottom-end"-->
<!--                            style="display: inherit">-->
<!--                            <template #reference>-->
<!--                                <van-button type="info" class="operation-btn" plain round style="border:none">· · ·</van-button>-->
<!--                            </template>-->
<!--                        </van-popover>-->
<!--                        <van-button-->
<!--                            v-if="item.btnList.includes(btnType.XZBH_BUTTON)"-->
<!--                            class="operation-btn"-->
<!--                            plain-->
<!--                            type="info"-->
<!--                            round-->
<!--                            @click="onBtnClick({-->
<!--                                    type: btnType.XZBH_BUTTON,-->
<!--                                    id: item.cId-->
<!--                                    })"-->
<!--                        >-->
<!--                            下载保函-->
<!--                        </van-button>-->
<!--                        <van-button-->
<!--                            v-if="item.btnList.includes(btnType.CXSQ_BUTTON)"-->
<!--                            class="operation-btn"-->
<!--                            plain-->
<!--                            type="info"-->
<!--                            round-->
<!--                            @click="onBtnClick({-->
<!--                                    type: btnType.CXSQ_BUTTON,-->
<!--                                    dbid: item.cId-->
<!--                                    })"-->
<!--                        >-->
<!--                            重新申请-->
<!--                        </van-button>-->
<!--                        <van-button-->
<!--                            v-if="item.btnList.includes(btnType.BJ_BUTTON)"-->
<!--                            class="operation-btn"-->
<!--                            plain-->
<!--                            type="info"-->
<!--                            round-->
<!--                            @click="onBtnClick({-->
<!--                                    type: btnType.BJ_BUTTON,-->
<!--                                    id: item.cId-->
<!--                                    })"-->
<!--                        >-->
<!--                            编辑-->
<!--                        </van-button>-->
<!--                        <van-button-->
<!--                            v-if="item.btnList.includes(btnType.SC_BUTTON)"-->
<!--                            class="operation-btn"-->
<!--                            plain-->
<!--                            type="info"-->
<!--                            round-->
<!--                            @click="onBtnClick({-->
<!--                                    type: btnType.SC_BUTTON,-->
<!--                                    id: item.cId-->
<!--                                    })"-->
<!--                        >-->
<!--                            删除-->
<!--                        </van-button>-->
<!--                        <van-button-->
<!--                                v-if="item.btnList.includes(btnType.SQBQ_BUTTON)"-->
<!--                                class="operation-btn"-->
<!--                                plain-->
<!--                                type="info"-->
<!--                                round-->
<!--                                @click="onBtnClick({-->
<!--                                    type: btnType.SQBQ_BUTTON,-->
<!--                                    id: item.cId-->
<!--                                    })"-->
<!--                        >-->
<!--                            申请保全-->
<!--                        </van-button>-->
<!--                    </div>-->
            </div>

        </van-list>

        <div class="fd-com-btn-container">
            <van-button
                type="info"
                round
                @click="createGuarantee">
                申请担保
            </van-button>
        </div>

        <div id="qr-code">
            <div class="canvasCode" id="qrcode">
            </div>
            <van-dialog
                    v-model="showQrCode"
                    title="中国人民财产保险保单交费"
                    showConfirmButton
                    confirmButtonColor="black"
            >
                <img class="img" :src="imgData"/>
            </van-dialog>
        </div>
    </div>
</template>

<script>
import QRcode from "qrcodejs2";
import wx from "weixin-js-sdk";
import MyTitle from "../../components/common/myTitle";
import { typeBqlb, typeBqlx } from "@/filters/index";
import { btnType, SQDB_SHOW_BTN_LIST, SQDB_TYPE_MAP } from "@/utils/consts";
import { Dialog, Toast } from "vant";
import { getToken } from "../../utils/auth";
import {
  checkTB,
  creatByChuHan,
  getDbbgVerify,
  reqDbbgSqbg,
} from "../../api/common";
// 代码值对应的工具方法
import code from "@/utils/code.js";
import { mapGetters } from "vuex";
import ccButtonList from "@/components/common/button-list/index.vue";

export default {
  data() {
    return {
      keyWord: "", // 搜索关键字
      total: 0, // 保全总数
      list: [],
      loading: false, // 列表加载状态
      finished: false, // 是否列表全部加载完成
      page: 0, // 页码
      size: 10, // 每页尺寸, 固定不会改变
      btnType: btnType,
      showQrCode: false, // 是否展示二维码弹层
      qrCodeUrl: "http://172.16.176.65:8085/account/testqrcode.jpg", // 二维码url
      imgData: "", // 二维码图片数据

      showPopover: false,
      actions: [
        { text: "选项一", value: "1" },
        { text: "选项二", value: "2" },
        { text: "选项三", value: "3" },
      ],
      buttonArr: {
        1: { text: "下载保单", type: btnType.XZBD_BUTTON },
        // 2:{text:'下载保函',type:btnType.XZBH_BUTTON},
        4: { text: "编辑", type: btnType.BJ_BUTTON },
        5: { text: "删除", type: btnType.SC_BUTTON },
        6: { text: "交费", type: btnType.JF_BUTTON },

        19: { text: "申请开票", type: btnType.SQKP_BUTTON },
        20: { text: "查看开票信息", type: btnType.CKKP_BUTTON },
        21: { text: "申请退保", type: btnType.SQTB_BUTTON },
        22: { text: "重新申请", type: btnType.CXSQ_BUTTON },
        23: { text: "申请变更", type: btnType.SQBG_BUTTON },
      },
    };
  },
  // 计算属性
  computed: {
    // 获取代码表
    ...mapGetters(["codeGetMap"]),
  },
  components: {
    MyTitle,
    ccButtonList,
  },
  methods: {

    /**
     * @function
     * @description 嵌入在线保全新增交互——申请保全
     * @return {undefined} 无返回值
     */
    createGuarantee() {
        this.$router.push({
            path: "/createGuarantee",
        });
    },

    /**
     * 按钮点击事件
     * @param {Object} btnItem 按钮信息项
     * @param {Object} dataItem 数据信息项
     * @returns {void}
     * */
    eClickBtn(btnItem, dataItem) {
      // 触发对应点击事件
      this.onBtnClick({
        type: btnItem.type,
        // id
        id: dataItem.cId,
        // 担保id
        dbid: dataItem.cId,
      });
    },

    onSelect(action, item) {
      console.log("--onSelect 456", action, item);
      // Toast(action.text);

      var object = {};
      switch (action.type) {
        case btnType.XZBD_BUTTON:
        case btnType.XZBH_BUTTON:
        case btnType.BJ_BUTTON:
        case btnType.SC_BUTTON:
          object = Object.assign({ id: item.cId }, action);
          break;
        case btnType.JF_BUTTON:
          object = Object.assign({ id: item.cId, cBxgs: item.cBxgs }, action);
          break;

        case btnType.SQKP_BUTTON:
          object = Object.assign(
            { dbid: item.cId, cBdh: item.cBdh, cBxgs: item.cBxgs },
            action
          );
          break;

        case btnType.SQTB_BUTTON:
          object = Object.assign(
            { dbid: item.cId, cBdh: item.cBdh, nSqbqje: Number(item.nSqbqje) },
            action
          );
          break;
        case btnType.CKKP_BUTTON:
        case btnType.CXSQ_BUTTON:
        case btnType.SQBG_BUTTON:
          object = Object.assign({ dbid: item.cId }, action);
          break;
        default:
          object = Object.assign({ id: item.cId }, action);
          break;
      }
      console.log("--object 444", object);
      this.onBtnClick(object);
    },

    //刷新页面
    refresh() {
      window.location.reload();
    },
    goDetail({ cId, btnList }) {
      if (btnList.indexOf(14) > -1) {
        window.sessionStorage.setItem("dbid", cId);
        this.$router.push({
          path: "/guaranteeDetail",
          query: {
            // 担保id
            id: cId,
          },
        });
      }

      // this.$axios.get('ssbq/api/ssdb/dbjbxx' + "?dbid=" + Id).then(res => {
      //     this.$router.push({
      //         path: '/guaranteeDetail'
      //     })
      // })
    },
    /**
     * 获取担保状态文本
     * @param {String} cDbzt 担保状态
     * @param {Number} nSfbgwc 申请变更次数
     * @returns {String}
     * */
    getDbztText(cDbzt, nSfbgwc) {
      if (cDbzt === "5") {
        return nSfbgwc > 0 ? "变更后已出函" : "已出函";
      }
      // 获取对应的代码值
      return code.getKeyName(this.codeGetMap("206000"), cDbzt);
    },
    loadData() {
      this.loading = true;
      this.$axios
        .get(
          "ssbq/api/xcx/yzwxcxdbsqs?page=" +
            ++this.page +
            "&rows=" +
            this.size +
            "&searchValue=" +
            encodeURI(this.keyWord)
        )
        .then((res) => {
          let data = res.data;
          this.total = data.total;
          let list = data.list;
          for (let db of list) {
            let temp = {
              // 保全id
              cId: db.cId,
              // 保全类别
              cBqlb: typeBqlb(db.cBqlb),
              // 保全类型
              cBqlx: typeBqlx(db.cBqlx),
              //保单号
              cBdh: db.cBdh,
              // 担保状态
              cDbzt: db.cDbzt,
              // 担保状态
              cDbztText: this.getDbztText(db.cDbzt, db.nSfbgwc),
              // 申请人姓名
              cSqrxm: db.cSqrxm,
              // 当事人姓名
              cDsrxm: db.cDsrxm,
              // 法院名称
              cFymc: db.cFymc,
              // 申请诉前保全金额
              nSqbqje: db.nSqbqje,
              // 支付金额
              nZfje: db.nZfje,
              // 担保机构建议担保费用
              nDbfy: db.nDbfy,
              // 担保机构名称
              cBxgsmc: db.cBxgsmc,
              // 担保机构类型
              cBxgs: db.cBxgs,
              cSqbh: db.cSqbh,
              // 要展示的按钮
              btnList: [],
              showPopover: false,
              actions: [],
              // 按钮数据信息项
              btnDatas: [],
            };
            if (db.showBtn) {
              temp.btnList = db.showBtn.split(",").map(Number);
              // 转化为按钮对象
              temp.btnList.forEach((btnItem) => {
                // 如果申请担保中显示按钮列表，则按钮数据中填入对应的按钮对象
                if (SQDB_SHOW_BTN_LIST.indexOf(btnItem) > -1) {
                  temp.btnDatas.push(SQDB_TYPE_MAP[btnItem]);
                }
              });
            }

            var actions = [],
              buttonArr = this.buttonArr;
            temp.btnList.map((i) => {
              buttonArr[i] && actions.push(buttonArr[i]);
            });
            temp.actions = actions;

            this.list.push(temp);
          }
          if (this.page * this.size >= this.total) {
            // 数据全部加载完成, 接口返回的totalPage为空, 采用另一种方法判断
            this.finished = true;
          }
          // 加载状态结束
          this.loading = false;
        })
        .catch(() => {});
    },
    onSearch: function () {
      // 搜索时重置页数和数据
      this.page = 0;
      this.list = [];
      // 需要重置finished值
      this.finished = false;
      // 加载数据
      this.loadData();
    },
    onBtnClick: function (param) {
      // 已出函申请保全
      if (param.type === this.btnType.SQBQ_BUTTON) {
        // 创建出函申请
        creatByChuHan({
          dbid: param.id,
        })
          .then((res) => {
            // 请求状态为200即成功
            if (res.code === 200) {
              // 将保全id放入session中
              sessionStorage.setItem("bqid", res.data.cId);
              // 跳转到一键申请保全页面
              this.$router.push("/guarantee-one-key");
            } else {
              this.$notify(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
        return;
      }

      //重新申请
      if (param.type === this.btnType.CXSQ_BUTTON) {
        console.log("--重新申请 123");
        sessionStorage.setItem("currentDbid", JSON.stringify(param.dbid));
        this.$router.push("/guaranteeInfo");
      }

      //申请变更
      if (param.type === this.btnType.SQBG_BUTTON) {
        console.log("--申请变更 123");

        getDbbgVerify({ dbid: param.dbid }).then((res1) => {
          console.log("--getDbbgVerify 123", res1);
          if (res1.code === 200) {
            if (res1.data.enableChangeGuarantee) {
              reqDbbgSqbg({ dbid: param.dbid }).then((res) => {
                console.log("--reqDbbgSqbg 123", res);
                sessionStorage.setItem("fromSQBG", "true");
                sessionStorage.setItem(
                  "currentDbid",
                  JSON.stringify(param.dbid)
                );
                this.$router.push({
                  path: "/guarantee-sqbg-info",
                  query: {
                    // 担保id
                    dbid: param.dbid,
                    // type类型
                    type: param.type,
                  },
                });
              });
            } else {
              this.$notify("您的担保正在使用中，不能变更！");
            }
          }
        });
      }

      //开票申请
      if (param.type === this.btnType.SQKP_BUTTON) {
        console.log("--开票申请 111", param);
        sessionStorage.setItem("kpInfo", JSON.stringify(param));
        this.$router.push("/kaiPiaoEdit");
        return false;
      }

      //查看申请开票信息
      if (param.type === this.btnType.CKKP_BUTTON) {
        sessionStorage.setItem("dbid", param.dbid);
        this.$router.push("/kaiPiaoInfo");
        return false;
      }

      //申请退保
      if (param.type === this.btnType.SQTB_BUTTON) {
        console.log("--开票退保 111", param);
        checkTB({ dbid: param.dbid }).then((res) => {
          console.log("--checkTB 123", res);
          if (res.code === 200) {
            if (!res.data.enableSurrender) {
              this.$notify(res.data.message);
            } else {
              sessionStorage.setItem("tbInfo", JSON.stringify(param));
              this.$router.push("/tuiBaoEdit");
            }
          }
        });
        return false;
      }

      if (param.type === this.btnType.XZBD_BUTTON) {
        wx.miniProgram.navigateTo({
          url:
            "/pages/download/download?id=" + param.id + "&token=" + getToken(),
        });
        // window.open(`${download.BD}?type=bd&dbid=` + param.id);
        return;
      }
      if (param.type === this.btnType.XZBH_BUTTON) {
        wx.miniProgram.navigateTo({
          url:
            "/pages/downloadBh/downloadBh?id=" +
            param.id +
            "&token=" +
            getToken(),
        });
        // window.open(`${download.BH}?type=bh&dbid=` + param.id);
        return;
      }
      if (param.type === this.btnType.BJ_BUTTON) {
        // 编辑
        sessionStorage.setItem("currentDbid", JSON.stringify(param.id));
        this.$router.push("/guaranteeInfo");
        return;
      }
      if (param.type === this.btnType.SC_BUTTON) {
        // 删除
        Dialog.confirm({
          title: "提示",
          message: "此操作将永久删除该条记录, 是否继续?",
          confirmButtonColor: "#ffffff",
          cancelButtonColor: "#ffffff",
        })
          .then(() => {
            this.$axios
              .delete("ssbq/api/ssdb/dbsq?dbid=" + param.id)
              .then((res) => {
                if (res.code === 204) {
                  this.$notify({
                    message: "删除成功",
                    type: "success",
                  });
                  this.page = 0;
                  this.list = [];
                  this.loadData();
                }
              });
          })
          .catch(() => {});
        return;
      }
      if (param.type === this.btnType.JF_BUTTON) {
        Toast("暂未开通小程序端交费，请使用电脑端进行交费！");
        // 处理人保, 众安, 平安三种保单交费
        //this.handleGuaranteePayment(param);
        return;
      }
      if (param.type === this.btnType.QXDB_BUTTON) {
        this.$axios.put("ssbq/api/ssdb/qxdb?dbid=" + param.id).then((res) => {
          if (res.code == 200) {
            this.$notify({
              type: "success",
              message: res.message,
            });
          }
          this.loadData();
        });
        return;
      }
      if (param.type === this.btnType.PJ_BUTTON) {
        sessionStorage.setItem("currentDbid", param.id);
        this.$router.push({
          path: "/guaranteeRate",
        });
        return;
      }
      if (param.type === this.btnType.XQ_BUTTON) {
        this.$router.push({
          path: "/guaranteeDetail",
        });
        return;
      }
      if (param.type === this.btnType.CKPJ_BUTTON) {
        sessionStorage.setItem("currentDbid", param.id);
        this.$router.push({
          path: "/guaranteeRate_CK",
        });
        return;
      }
    },
    canvasToBase64: function (myCanvas) {
      let base64Data = myCanvas.toDataURL("image/png");
      return base64Data;
    },
    handleGuaranteePayment: function (param) {
      // 弹出展示人保交费二维码
      this.$axios
        .post("commonapi/api/policy/guarantee/payurl?jbxxid=" + param.id)
        .then((res) => {
          if (param.cBxgs == "001") {
            // 人保
            if (res.code == 200) {
              // 弹出展示人保交费二维码
              this.showQrCode = true;
              // this.qrCodeUrl = "weixin://wxpay/bizpayurl?pr=WjdunnT"; // 测试数据
              // 获取交费二维码url
              this.qrCodeUrl = res.data.payUrl;
              let canvas = document.getElementById("canvas");
              QRcode.toCanvas(canvas, this.qrCodeUrl, function (error) {
                if (error) console.error(error);
              });
              var img = this.canvasToBase64(canvas);
              this.imgData = img;
            } else {
              console.log("获取人保交费二维码失败", JSON.stringify(res));
              this.$notify(res.message);
            }
          }
          if (param.cBxgs == "002") {
            // 平安
            wx.miniProgram.navigateTo({
              url: "/pages/payFee/payFee?id=" + param.id,
            });
          }
          if (param.cBxgs == "003") {
            // 众安保险公司
            if (res.code == 200) {
              window.open(res.data.payUrl);
            } else {
              console.log("获取众安交费连接失败", JSON.stringify(res));
              this.$notify(res.data.message);
            }
          }
        });
    },
  },
  created() {
    sessionStorage.removeItem("fromSQBG");
    // 获取担保申请的担保进展阶段代码值
    this.$store.dispatch("GetCodeType", 206000);
    this.loadData();
  },
};
</script>

<style lang="less" scoped>
#qr-code {
  display: none;
  text-align: center;
}
</style>
